import { UnlayerDesign } from '@Types/unlayer';

// empty state of the HTML Editor
export const EMPTY_EDITOR_DESIGN: UnlayerDesign = {
  body: {
    id: 'root',
    rows: [
      {
        id: 'row_1',
        cells: [1],
        columns: [
          {
            id: 'column_1',
            contents: [],
            values: {
              backgroundColor: '',
              padding: '20px',
            },
          },
        ],
        values: {
          backgroundColor: '',
          padding: '0px',
        },
      },
    ],
    values: {},
  },
};
